import React from 'react';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';
import Header from './Header';

const Layout: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <Container component="footer" maxWidth="lg" sx={{ py: 2, textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          <Link component={RouterLink} to="/help" color="inherit">
            How JobFlo works
          </Link>
          {' · '}
          <Link component={RouterLink} to="/terms" color="inherit">
            Terms of Service
          </Link>
          {' · '}
          <Link component={RouterLink} to="/privacy" color="inherit">
            Privacy Policy
          </Link>
          {' · '}
          <Link href="mailto:support@jobflo.me" color="inherit">
            support@jobflo.me
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Layout;